import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useFormik } from "formik";
import * as yup from "yup";
import { ValidationCons } from "../validation/validationConstant";
import { updateAccountDetails } from "../service/apis/auth.api";
import { setUser } from "../store/auth.store";
import { showError, showSuccess } from "../utils/Common";

const ResidentialDetailsScreen = () => {
  const dispatch = useDispatch();

  const [showResidential, setShowResidential] = useState(false);
  const handleCloseR = () => setShowResidential(false);
  const handleShowR = () => setShowResidential(true);

  const { user } = useSelector((state: RootState) => state.authSlice);

  const residentialProfileik = useFormik({
    initialValues: {
      country: user?.address?.country || "",
      state: user?.address?.state || "",
      city: user?.address?.city || "",
      street: user?.address?.street || "",
      zipcode: user?.address?.zipcode || "",
    },
    validationSchema: yup.object({
      country: yup
        .string()
        .trim()
        .required(ValidationCons.COUNTRY_NAME_REQUIRED),
      state: yup.string().trim().required(ValidationCons.STATE_NAME_REQUIRED),
      city: yup.string().trim().required(ValidationCons.CITY_NAME_REQUIRED),
      street: yup.string().trim().required(ValidationCons.STREET_NAME_REQUIRED),
      zipcode: yup.string().trim().required(ValidationCons.ZIPCODE_REQUIRED),
    }),
    onSubmit: async (values: any) => {
      // setLoading(true);
      // console.log(222);

      try {
        let bodyData = {
          "address[country]": values.country,
          "address[city]": values.city,
          "address[state]": values.state,
          "address[street]": values.street,
          "address[zipcode]": values.zipcode,
        };

        const response = await updateAccountDetails(bodyData);
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleCloseR();
            dispatch(setUser(response.user));
            showSuccess("Residential detail Updated successfully");
          }
        }
      } catch (error: any) {
        //   setLoading(false);
        showError(error?.message);
      }
    },
  });

  return (
    <>
      <div className="comnbrdrGap profileEdit mb-4">
        <div className="d-flex">
          <h3>My Residential Details</h3>
          <button className="editbtn" onClick={handleShowR}>
            <LuPencilLine /> Edit
          </button>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <p>Country</p>
            <h6>{user?.address?.country}</h6>
          </div>
          <div className="col-lg-4">
            <p>City</p>
            <h6>
              {user?.address?.city} {user?.address?.city && user?.address?.state && ( `,` )} {user?.address?.state}
            </h6>
          </div>
          <div className="col-lg-4">
            <p>Address</p>
            <h6>{user?.address?.street}</h6>
          </div>
        </div>
        <p>Pin Code</p>
        <h6>{user?.address?.zipcode}</h6>
      </div>

      {/* Edit Residential Details model*/}
      <Modal
        show={showResidential}
        onHide={handleCloseR}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Edit Residential Details</h3>
            <Form
              className="modalSearch"
              onSubmit={residentialProfileik.handleSubmit}
            >
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="United Kingdom"
                  name="country"
                  onChange={residentialProfileik.handleChange}
                  onBlur={residentialProfileik.handleBlur}
                  value={residentialProfileik.values.country}
                  isInvalid={
                    !!residentialProfileik.errors.country &&
                    Boolean(residentialProfileik.touched.country)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof residentialProfileik.errors.country === "string" &&
                    residentialProfileik.errors.country}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>State</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="New York"
                  name="state"
                  onChange={residentialProfileik.handleChange}
                  onBlur={residentialProfileik.handleBlur}
                  value={residentialProfileik.values.state}
                  isInvalid={
                    !!residentialProfileik.errors.state &&
                    Boolean(residentialProfileik.touched.state)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof residentialProfileik.errors.state === "string" &&
                    residentialProfileik.errors.state}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Leeds"
                  name="city"
                  onChange={residentialProfileik.handleChange}
                  onBlur={residentialProfileik.handleBlur}
                  value={residentialProfileik.values.city}
                  isInvalid={
                    !!residentialProfileik.errors.city &&
                    Boolean(residentialProfileik.touched.city)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof residentialProfileik.errors.city === "string" &&
                    residentialProfileik.errors.city}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="1/A2 Lorem Ipsum"
                  name="street"
                  onChange={residentialProfileik.handleChange}
                  onBlur={residentialProfileik.handleBlur}
                  value={residentialProfileik.values.street}
                  isInvalid={
                    !!residentialProfileik.errors.street &&
                    Boolean(residentialProfileik.touched.street)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof residentialProfileik.errors.street === "string" &&
                    residentialProfileik.errors.street}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Pin Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="754231"
                  name="zipcode"
                  onChange={residentialProfileik.handleChange}
                  onBlur={residentialProfileik.handleBlur}
                  value={residentialProfileik.values.zipcode}
                  isInvalid={
                    !!residentialProfileik.errors.zipcode &&
                    Boolean(residentialProfileik.touched.zipcode)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof residentialProfileik.errors.zipcode === "string" &&
                    residentialProfileik.errors.zipcode}
                </Form.Control.Feedback>
              </Form.Group>
              <Button className="btn w-100" type="submit">
                Save
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Edit Residential Details model*/}
    </>
  );
};
export default ResidentialDetailsScreen;
